import moment from 'moment'

export const defaultSearchDate = [
  moment().subtract(90, 'd').format('YYYY-MM-DD 00:00:00'),
  moment().format('YYYY-MM-DD 00:00:00'),
]
